const store = {
  namespaced: true,
  state: {
    filterProjectPartsDialog: false,
    currentTabTypePushMoney: "project"
  },
  getters: {},
  mutations: {
    setFilterProjectPartsDialog(state, data) {
      state.filterProjectPartsDialog = data;
    },
    setCurrentTabTypePushMoney(state, data) {
      state.currentTabTypePushMoney = data;
    }
  },
  actions: {
    async updateBusinessCommission({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/updateBusinessCommission", params);
      return data;
    },
    async getBusinessCommissionConfig({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/getBusinessCommissionConfig", params);
      return data;
    },
    async updateStaffMonthlySalaryRecord({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/updateStaffMonthlySalaryRecord", params);
      return data;
    },
    async getStaffMonthlySalaryRecord({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/getStaffMonthlySalaryRecord", params);
      return data;
    },
    async grantStaffMonthlySalaryRecord({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/grantStaffMonthlySalaryRecord", params);
      return data;
    },
    async getStaffMonthlySalaryRecordPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/getStaffMonthlySalaryRecordPage", params);
      return data;
    },
    async getStaffSalaryConfig({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/getStaffSalaryConfig", params);
      return data;
    },
    async updateStaffSalaryConfig({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/updateStaffSalaryConfig", params);
      return data;
    },
    async deleteStaffSalaryConfig({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/deleteStaffSalaryConfig", params);
      return data;
    },
    async updateStaffSalaryTemplate({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/updateStaffSalaryTemplate", params);
      return data;
    },
    async createStaffSalaryConfig({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/createStaffSalaryConfig", params);
      return data;
    },
    async getStaffSalaryConfigPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/getStaffSalaryConfigPage", params);
      return data;
    },
    async getStaffSalaryTemplate({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/getStaffSalaryTemplate", params);
      return data;
    },
    async getStaffCommissionDetail({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/getStaffCommissionDetail", params);
      return data;
    },
    async deleteBusinessCommission({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/deleteBusinessCommission", params);
      return data;
    },
    async updateStaffSalarySetting({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/updateStaffSalarySetting", params);
      return data;
    },
    async deleteStaffSalarySetting({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/deleteStaffSalarySetting", params);
      return data;
    },
    async createStaffSalarySetting({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/createStaffSalarySetting", params);
      return data;
    },
    async getStaffMonthlySalaryPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/getStaffMonthlySalaryPage", params);
      return data;
    },
    async getStaffSalarySettingPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/salary/getStaffSalarySettingPage", params);
      return data;
    },
    async getStaffCommissionSummaryPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/getStaffCommissionSummaryPage", params);
      return data;
    },
    async getStaffCommissionPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/getStaffCommissionPage", params);
      return data;
    },
    async getPartsCommissionPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/getPartsCommissionPage", params);
      return data;
    },
    async createBusinessCommission({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/createBusinessCommission", params);
      return data;
    },
    async getPartsPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/getPartsPage", params);
      return data;
    },
    async getServiceItemPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/getServiceItemPage", params);
      return data;
    },
    async getServicesCommissionPage({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/getServicesCommissionPage", params);
      return data;
    },
    async queryCategoryCommission({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/queryCategoryCommission", params);
      return data;
    },
    async queryServicesCommission({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/queryServicesCommission", params);
      return data;
    },
    async queryPartsCommission({ rootState }, params = {}) {
      const data = await rootState.http("/staff/commission/queryPartsCommission", params);
      return data;
    }
  }
};
export default store;
